// Geo-based redirects using Shopify `/browsing_context_suggestions.json`
// Rules:
// - Allow full access for KR and JP on this store (no redirect)
// - Redirect US to the US store
// - Redirect every other country to the Global store
(function () {
  var ALLOWED_ON_THIS_STORE = ['KR', 'JP'];
  var URL_US = 'https://adro.com/';
  var URL_GLOBAL = 'https://global.adro.com/';

  function handleCountry(code) {
    if (!code) return;
    code = String(code).toUpperCase();
    if (ALLOWED_ON_THIS_STORE.indexOf(code) !== -1) return;
    window.location.replace(code === 'US' ? URL_US : URL_GLOBAL);
  }

  function init() {
    if (typeof window.fetch !== 'function') return;
    try {
      fetch(
        '/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false',
        { credentials: 'same-origin' }
      )
        .then(function (response) { return response && response.ok ? response.json() : null; })
        .then(function (data) {
          if (!data) return;
          var c =
            (data.detected_values && data.detected_values.country) ||
            (data.suggestions &&
              data.suggestions[0] &&
              data.suggestions[0].parts &&
              data.suggestions[0].parts.country);
          var code = c && (c.handle || c.iso_code || c.code);
          if (code) handleCountry(code);
        })
        .catch(function () {});
    } catch (e) {}
  }

  init();
})();

